import React, {useEffect, useState} from 'react';
import styles from "./MenuButton.module.css";
import ReportIcon from "../Icons/ReportIcon";

// type: "normal", "sub"
const MenuButton = ({label, type, onClick, selected, notificationEffectFunc}) => {

    const [notificationVisible, setNotificationVisible] = useState(false)

    useEffect(() => {

        if (notificationEffectFunc)
            return notificationEffectFunc(setNotificationVisible);
    }, []);

    function getClassName() {
        let result = type === "sub" ? styles.sub_menu : styles.menu;
        if (selected)
            result += " " + styles.selected;
        return result;
    }

    return (
        <div className={styles.main_div}>
            <button className={getClassName()} onClick={onClick}>
                {label}
            </button>
            {notificationVisible && <ReportIcon fgColor="#446688" bgColor="#446688" bgOpacity={0.15} sx={{position: "absolute", right: "4px", top: "8px"}}/>}
        </div>
    );
};

export default MenuButton;